import styled from 'styled-components';
import { device } from './responsives';

export const LoadCardContainer= styled.div`
  @media ${device.minLaptop}{
  display: grid;
  margin-left: 30%;
  margin-right: 30%;
  }
  @media ${device.mobileL}{
    margin: 0px;
    padding: 0px;
  }
`
export const LoadImage= styled.img`
  width: 300px;
  height: 300px;
  aspect-fit: cover;
  display: inline-block;
  padding: 0px;
  @media ${device.mobileL}{
    width: 280px;
    height: 300px;
  }
`

export const Banner=styled.div`
  height: auto;
  font-family: Avenir;
  font-weight: 900;
  font-size: 32px;
  text-align: center;
  color: #4a4a4a;
  padding-top: 30%;
  @media ${device.mobileL}{
    padding-top: 10%;
  }

`
